import api from './api';
import { AutomationRule, AutomationStats, ExecutionLog, AISuggestion } from '../types';

interface AutomationRuleFormData {
  name: string;
  description: string;
  platform: string[];
  trigger_type: string;
  trigger_value: number;
  action_type: string;
  action_value: number;
  frequency: string;
  status?: string;
  campaign_ids?: string[];
}

export const automationService = {
  async getRules(campaignId?: string) {
    const params: Record<string, string> = {};
    if (campaignId) params.campaign_id = campaignId;
    const response = await api.get('/automation/rules', { params });
    return response.data;
  },

  async createRule(data: AutomationRuleFormData) {
    const response = await api.post('/automation/rules', data);
    return response.data;
  },

  async updateRule(id: string, data: AutomationRuleFormData) {
    const response = await api.put(`/automation/rules/${id}`, data);
    return response.data;
  },

  async deleteRule(id: string) {
    const response = await api.delete(`/automation/rules/${id}`);
    return response.data;
  },

  async toggleStatus(id: string, status: 'active' | 'paused') {
    const response = await api.patch(`/automation/rules/${id}/status`, { status });
    return response.data;
  },

  async getStats(campaignId?: string) {
    const params: Record<string, string> = {};
    if (campaignId) params.campaign_id = campaignId;
    const response = await api.get('/automation/stats', { params });
    return response.data;
  },

  async getSuggestions(campaignId?: string) {
    const params: Record<string, string> = {};
    if (campaignId) params.campaign_id = campaignId;
    const response = await api.get('/automation/suggestions', { params });
    return response.data;
  },

  async getLogs(campaignId?: string) {
    const params: Record<string, string> = {};
    if (campaignId) params.campaign_id = campaignId;
    const response = await api.get('/automation/logs', { params });
    return response.data;
  },

  async getConnectedPlatforms() {
    const response = await api.get('/social/accounts', { params: { include_ads: 'true' } });
    if (response.data.success && response.data.data) {
      const adsAccounts = response.data.data.filter((a: any) =>
        a.platform === 'google_ads' || a.platform === 'facebook_ads' || a.platform === 'linkedin_ads' || a.platform === 'linkedin'
      );
      const platforms: string[] = [];
      adsAccounts.forEach((account: any) => {
        if (account.platform === 'google_ads' && !platforms.includes('google')) platforms.push('google');
        else if (account.platform === 'facebook_ads' && !platforms.includes('meta')) platforms.push('meta');
        else if ((account.platform === 'linkedin_ads' || account.platform === 'linkedin') && !platforms.includes('linkedin')) platforms.push('linkedin');
      });
      return platforms;
    }
    return [];
  }
};
